import React from 'react';
import iconNs from '@ant-design/icons';

const Icon = iconNs.default || iconNs;

export function FileUploadFieldIconComponent() {
  return (
    <svg width="1em" height="1em" viewBox="0 0 1000 1000" style={{ enableBackground: 'new 0 0 1000 1000' }} role="img" >
      <path d="m687.73 299.38-212.7-200.9c-12.57-11.85-32.24-11.87-44.81.02L217.53 299.4c-13.09 12.36-13.68 33.01-1.3 46.11 12.39 13.11 33.04 13.69 46.11 1.3l157.67-148.92v463.03c0 18.01 14.61 32.61 32.61 32.61s32.61-14.61 32.61-32.61V197.89l157.68 148.94a32.601 32.601 0 0 0 22.41 8.89c8.66 0 17.29-3.42 23.72-10.21 12.37-13.11 11.78-33.75-1.31-46.13z" style={{ fill: '#666' }} />
      <path d="M452.62 760.23c-54.76 0-99.31-44.55-99.31-99.31V467.8H144.06c-28.1 0-50.95 22.84-50.95 50.95V782.5c0 28.1 22.84 50.97 50.95 50.97h610c28.1 0 50.97-22.86 50.97-50.97V518.74c0-28.1-22.86-50.95-50.97-50.95H551.93v193.13c0 54.76-44.55 99.31-99.31 99.31z" style={{ fill: '#f2f2f2' }} />
      <path d="M754.06 429.43H551.93v38.36h202.13c28.1 0 50.97 22.84 50.97 50.95v263.75c0 28.1-22.86 50.97-50.97 50.97h-610c-28.1 0-50.95-22.86-50.95-50.97V518.74c0-28.1 22.84-50.95 50.95-50.95h209.25v-38.36H144.06c-49.24 0-89.31 40.07-89.31 89.31v263.75c0 49.26 40.07 89.33 89.31 89.33h610c49.26 0 89.33-40.07 89.33-89.33V518.74c0-49.23-40.07-89.31-89.33-89.31z" style={{ fill: '#666' }} />
    </svg>
  );
}

function FileUploadFieldIcon() {
  return (
    <Icon component={FileUploadFieldIconComponent} />
  );
}

export default FileUploadFieldIcon;
